import FundHeader from '@/components/Fund-HqHeader.vue';
import WarningTip from '@/components/Warning-Tip.vue';
import WarningBar from '@/components/Warning-Bar.vue';
import WarningAnBar from '@/components/Warning-BarAn.vue';
import WarningnewBar from '@/components/Warning-Barnewtop.vue';
import WarningMidBar from '@/components/Fund-Mid-Bar.vue';
import FundCorrelationIndex from '@/components/Fund-CorrelationIndex.vue';
import Market from '@/components/Market.vue';
import FundReport from '@/components/Fund-Report.vue';
import FundChartMarket from '@/components/FundChart/market.vue';
import FundFeatures from '@/components/Fund-Features.vue';
import FundTradingInfo from '@/components/Fund-TradingInfo.vue';
import FundPositions from '@/components/Fund-Positions.vue';
import FundSize from '@/components/Fund-Size.vue';
import FundGeneralSituation from '@/components/Fund-GeneralSituation.vue';
import FundManager from '@/components/Fund-Manager.vue';
import FundDividendDistribution from '@/components/Fund-DividendDistribution.vue';
import FundQuestion from '@/components/Fund-Question.vue';
import FundComments from '@/components/Fund-Comments.vue';
import FundNews from '@/components/Fund-News.vue';
import FundAnnouncement from '@/components/Fund-Announcement.vue';
import FundDynamic from '@/components/Fund-Dynamic.vue';
import FundFooterTips from '@/components/Fund-FooterTips.vue';
import FundOperationPanel from '@/components/Fund-OperationPanel.vue';
import FundNavView from '@/components/Fund-NavView.vue';
import FundNavViewSp from '@/components/Fund-NavViewspView.vue';
import FundNavViewBack from '@/components/Fund-NavViewBack.vue';
import FundNavViewNext from '@/components/Fund-NavViewspNextView.vue';
import FundNewFlow from '@/components/Fund-new-flow.vue';
import FundADAction from '@/components/Fund-ADAction.vue';
import FundCfhKq from '@/components/Fund-cfh-Kq.vue';
import FundVideo from '@/components/Fund-Video.vue';
import AddToHome from '@/components/Fund-addToHome.vue';
import BarAndQue from '@/components/Fund-BarAndQue.vue';
import NewAndCon from '@/components/Fund-newAndCon.vue';
import TianTianView from '@/components/Fund-TiantianView.vue';
import ChartLoad from '@/components/Fund-chartLoad.vue';

export default {
  components: {
    TianTianView,
    NewAndCon,
    WarningBar,
    WarningMidBar,
    WarningnewBar,
    FundNavView,
    FundHeader,
    WarningTip,
    FundCorrelationIndex,
    Market,
    FundReport,
    FundChartMarket,
    FundFeatures,
    FundTradingInfo,
    FundPositions,
    FundSize,
    FundGeneralSituation,
    FundManager,
    FundDividendDistribution,
    FundQuestion,
    FundComments,
    FundNews,
    FundAnnouncement,
    FundFooterTips,
    FundOperationPanel,
    FundNewFlow,
    FundADAction,
    FundCfhKq,
    FundVideo,
    FundDynamic,
    FundNavViewBack,
    FundNavViewSp,
    FundNavViewNext,
    BarAndQue,
    ChartLoad,
    WarningAnBar,
    AddToHome,
  },
};
